import React, { Component } from 'react';
import { Log, Level, Logger } from 'ng2-logger';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import { Common } from '../../core/common';
import Moment from 'moment';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import * as Actions from '../../store/actions/announcementPage';
import * as CoursePageActions from '../../store/actions/coursePage';
import { IAnnouncementPageProps } from '../../models/pages/announcementPage';
import { IAnnouncement } from '../../models/action/announcement';
import SelectedAnnouncement from '../../components/announcements/selectedAnnouncement/main';
import AddAnnouncement from '../../components/announcements/addAnnouncement/main';
import { SecureImage } from '../../components/core/secureImage';
import { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';
import { IPreference } from '../../models/action/profile';
import { Guid } from 'guid-typescript';
import queryString from 'querystring';
import ContentLoader from 'react-content-loader';
import announcement from '../../static/images/announcement.svg';
import ReactGA from 'react-ga4';

const T = Translator.create();
const _logger = Log.create('Announcement Page');
let _common: Common;

const SENT_TAB = '1';
const ARCHIVE_TAB = '2';
const INBOX_TAB = '4';

let currentTab: string;
let photoKey: string;

class AnnouncementMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        currentTab = INBOX_TAB;
        photoKey = Guid.create().toString();
        _common = new Common();
        this.state = {
            isAnnouncementModalOpen: false,
            isSearchBoxOpen: false,
            searchedWord: '',
            isSearchBoxShow: false,
            isChatOpen: false, // Chat görünümünü kontrol eden state
        };

        if (T.i18next.language === 'tr') {
            Moment.locale('tr');
        }
        if (T.i18next.language === 'en') {
            Moment.locale('en');
        }
        this.onTabChange = this.onTabChange.bind(this);
    }

    public componentDidMount = () => {
        this.props.dispatch(Actions.setSelectedAnnouncementDataDefault());
        if (this.props.classId && this.props.courseId) {
            this.props.dispatch(
                Actions.getCourseAnnouncementsAction(
                    this.props.classId,
                    this.props.courseId,
                    'selectedAnnouncement',
                    'get',
                    20,
                    0,
                    this.callbackForDidMount
                )
            );
        } else {
            this.props.dispatch(Actions.getAnnouncementsAction(INBOX_TAB, 'selectedAnnouncement', 'get', 20, 0, this.callbackForDidMount));
        }

    };

    public callbackForDidMount = () => {
        if (!this.handleSearchQueryIfExists()) {
            this.callback();
        }
    }

    public callback = () => {
        if (this.props.announcements && this.props.announcements.length > 0) {
            this.props.dispatch(Actions.getSelectedAnnouncementAction(this.props.announcements[0].announcementId, '', 'get', 0));
        } else {
            this.props.dispatch(Actions.setSelectedAnnouncementDataDefault());
        }
    };

    public handleSearchQueryIfExists() {
        const search = window.location.search;
        const params = queryString.parse(search.replace('?', ''));
        const announcementId = params.announcementId ? String(params.announcementId) : null;
        if (announcementId) {
            const itemIndex = this.props.announcements.findIndex((item: any) => item.announcementId === announcementId);
            if (announcementId && itemIndex) {
                this.selectAnnouncement(announcementId, itemIndex);
                this.scrollToItem(announcementId);
                return true;
            }
            return false;
        }
        return false;
    }

    public scrollToItem(announcementId: string) {
        const element: HTMLElement | null = document.getElementById(announcementId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }

    componentDidUpdate(prevProps: any) {
        if (
            (this.props.announcements && this.props.announcements.length) !== (prevProps.announcements && prevProps.announcements.length) &&
            this.props.announcements.length &&
            this.props.announcementSkip === 0
        ) {
            if (!this.handleSearchQueryIfExists()) {
                this.props.dispatch(Actions.getSelectedAnnouncementAction(this.props.announcements[0].announcementId, 'selectedAnnouncement', 'get', 0));
            }
        }
    }

    public selectAnnouncement = (announcementId: string, index: number) => {
         // **Bir duyuru seçildiğinde chat görünümünü açıyoruz**
         this.setState({ isChatOpen: true });
        this.props.dispatch(Actions.getSelectedAnnouncementAction(announcementId, 'getSelectedAnnouncement', 'get', index, this.callbackForSelectAnnouncement));
    };

    public callbackForSelectAnnouncement = () => {
        const parentDiv = document.getElementById('announcement-selected');
        if (parentDiv) {
            parentDiv.style.opacity = '1';
        }
    }

    public onTabChange = (nextTab: string) => {
        if (!this.props.classId && currentTab !== nextTab) {

            if (nextTab == "1") {
                ReactGA.event({
                    category: window.location.host,
                    action: 'G_RECEIVED_ANNOUNCEMENT_CLICKED',
                    label: 'G_RECEIVED_ANNOUNCEMENT_CLICKED',
                    nonInteraction: true,
                });
            }
            else if (nextTab == "4") {
                ReactGA.event({
                    category: window.location.host,
                    action: 'G_SENT_ANNOUNCEMENT_CLICKED',
                    label: 'G_SENT_ANNOUNCEMENT_CLICKED',
                    nonInteraction: true,
                });
            }
            currentTab = nextTab;
            this.props.dispatch(Actions.getAnnouncementsAction(currentTab, 'selectedAnnouncement', 'get', 20, 0, this.callback));
        }
    };

    public onScrollDetected = (event: any) => {
        const element = event.target;
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            if (this.props.classId && this.props.courseId) {
                this.props.dispatch(
                    Actions.getCourseAnnouncementsAction(
                        this.props.classId,
                        this.props.courseId,
                        '',
                        'get',
                        this.props.announcementTake,
                        this.props.announcementSkip + 20
                    )
                );
            } else {
                this.props.dispatch(
                    Actions.getAnnouncementsAction(currentTab, '', 'get', this.props.announcementTake, this.props.announcementSkip + 20)
                );
            }
        }
    };

    public modalTrigger = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ADD_ANNOUNCEMENT_CLICKED',
            label: 'G_ADD_ANNOUNCEMENT_CLICKED',
            nonInteraction: true,
        });
        this.setState({
            isAnnouncementModalOpen: !this.state.isAnnouncementModalOpen
        });
    };

    public setCloseModal = () => {
        const addActivityModal = document.getElementsByClassName('add-activity-modal');
        if (addActivityModal) {
            addActivityModal[0].classList.remove('slideInRight');
            addActivityModal[0].classList.add('slideOutRight');
        }
        setTimeout(() => {
            this.setState({ isAnnouncementModalOpen: !this.state.isAnnouncementModalOpen });
        }, 300);
    };

    public findDateFormat = (isDateTimeFormik: boolean) => {
        let dateFormat = 'DD.MM.YYYY';

        if (this.props.userPreferences && this.props.userPreferences.length > 0) {
            dateFormat = (this.props.userPreferences.find((pref: any) => pref.name === 'application.dateformat') as IPreference).value;
        }

        if (isDateTimeFormik) {
            switch (dateFormat) {
                case 'DD.MM.YYYY':
                    return 'd.m.Y';
                case 'MM.DD.YYYY':
                    return 'm.d.Y';
                default:
                    return 'd.m.Y';
            }
        }

        return dateFormat;
    };

    triggerSearchBox = () => {
        this.setState({
            isSearchBoxOpen: !this.state.isSearchBoxOpen,
            isSearchBoxShow: true
        });
    };

    getAnnouncementList = (isClosed: boolean) => {
        this.props.dispatch(
            Actions.getAnnouncementsAction(currentTab, 'selectedAnnouncement', 'get', 20, 0, this.callback, !isClosed ? this.state.searchedWord: '')
        );
    };

    searchOnChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ searchedWord: event.target.value });

    searchOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.state.searchedWord && this.state.searchedWord.length && event.keyCode === 13) {
            this.getAnnouncementList(false);
        } else if (!this.state.searchedWord.length && event.keyCode === 8 /* backspace */) {
            this.getAnnouncementList(false);
        }
    };

    searchOnClose = () => {
        this.setState(
            this.setState({
                searchedWord: '',
                isSearchBoxOpen: !this.state.isSearchBoxOpen,
                isSearchBoxShow: !this.state.isSearchBoxShow
            }));
            this.getAnnouncementList(true);
    };
    openAnnouncement = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_X_ANNOUNCEMENT_CLICKED',
            label: 'G_X_ANNOUNCEMENT_CLICKED',
            nonInteraction: true,
        });
        const item = document.getElementById('announcement-selected');
        // if (item) {
        //     item.className = 'announcement-section p-0 mobile_chat_panel display_sm';
        // }
    }

    viewSearchClass = () => {
        if (this.state.isSearchBoxOpen) {
            return "search-bars collapse animated show slideInRight"
        }
        else {
            return "search-bars animated slideOutRight collapse show";
        }
    }
    public render() {
        const loadingSpaces = 96;
        const renderHtml = (
            <>
                {this.props.announcements && this.props.announcements.length && this.props.announcements.length > 0 ? (
                    <div>
                        {this.props.announcements.map((announcement: IAnnouncement, index: number) => (
                            <div
                                id={announcement.announcementId}
                                key={'announcement-' + index}
                                className={
                                    this.props.selectedAnnouncement
                                        ? announcement.announcementId === this.props.selectedAnnouncement.announcementId
                                            ? 'media active'
                                            : 'media'
                                        : 'media'
                                }
                            >
                                {!announcement.isRead && currentTab === INBOX_TAB ? <div className={'notify-dot'} /> : ''}
                                {announcement.fromAvatarPath ? (
                                    <SecureImage
                                        key={photoKey}
                                        style={{ borderRadius: 100, minWidth: 40, minHeight: 40 }}
                                        class={'userProfile'}
                                        imageUrl={announcement.fromAvatarPath}
                                    />
                                ) : (
                                    ''
                                )}
                                <div className={'media-body'} onClick={this.selectAnnouncement.bind(this, announcement.announcementId!, index)}>
                                    <div className="row announcement-type">
                                        <div className="col-6">
                                            <span>{T.t('r_gen_general')}</span>
                                        </div>
                                        <div className="col-6 text-right">
                                            {Moment(announcement.createdDate ? announcement.createdDate : '').fromNow()}
                                        </div>
                                    </div>
                                    <h5 className={(!_common.isArabic(announcement.subject, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>{announcement.subject}</h5>
                                    <h6 className={(!_common.isArabic(announcement.body, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}>
                                        <span>{announcement.fromDisplayName}</span>:{' '}
                                        <h6
                                        className={(!_common.isArabic(announcement.body, document.body.getAttribute('dir')) ? ' arabic-text-direction pt-2' : 'pt-2')}
                                            style={{ lineHeight: 1.145, textAlign: 'justify', textJustify: 'inter-word' }}
                                            dangerouslySetInnerHTML={{
                                                __html: announcement.body
                                                    ? announcement.body.length > 180
                                                        ? announcement.body.slice(0, 180).replace(/<\/?[^>]+(>|$)/g, '') + ' ...'
                                                        : announcement.body.replace(/<\/?[^>]+(>|$)/g, '')
                                                    : ''
                                            }}
                                        />
                                    </h6>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="media">
                        <h6>
                            <span>{T.t('r_home_box_announcement_not_found')}</span>
                        </h6>
                    </div>
                )}
            </>
        );



        return (
            <div>
                {this.state.isAnnouncementModalOpen ? (
                    <AddAnnouncement
                        findDateFormat={this.findDateFormat}
                        setCloseModal={this.setCloseModal}
                        isModalOpen={this.state.isAnnouncementModalOpen}
                        onTabChange={this.onTabChange}
                        classId={this.props.classId}
                        courseId={this.props.courseId}
                    />
                ) : null}
                <div className="content-container announcement" >
                    <div id={this.props.id} className="announcement-sidebar messages_list_sidebar" onScroll={this.onScrollDetected} style={{ overflow: 'scroll', overflowX: 'hidden' }}>
                        <div  style={{ background: 'rgba(0, 0, 0, 0.08)' }}>
                            <div  className="mobile-message-search d-flex justify-content-between align-items-center" style={{padding:'.5em'}}>
                                <div className="w-100 d-flex justify-content-between align-items-center mt-0">
                                    <span style={{ fontSize: '1.25em', fontWeight: '500' }}>{T.t('r_menu_announcements')}</span>
                                    <div className="options d-inline-flex align-items-center gap-1">

                                        <a
                                            className='d-flex align-items-center'
                                            data-toggle="collapse"
                                            href="#assignment-search"
                                            aria-expanded="true"
                                            onClick={this.triggerSearchBox}
                                        >
                                            <i className="material-icons">search</i>
                                        </a>

                                        {Common.HasPermission(
                                            SecurityContextType.Organization,
                                            SecurityPermissionType.Announcement_Add,
                                            ''
                                        ) &&
                                            (
                                                <a className="d-flex align-items-center" onClick={this.modalTrigger}>
                                                    <i className="material-icons">add</i>
                                                </a>
                                            )}
                                    </div>
                                </div>

                            </div>
                            <div id="searchConversations" className={'mobile-message-input-search  search' + (this.state.isSearchBoxShow ? ' collapse show' : ' collapse')}>
                            <div className="input-group">
                                <div data-toggle="collapse" className="input-group-prepend" onClick={this.searchOnClose}>
                                    <div className="input-group-text"  style={{cursor: "pointer"}}>
                                        <i className="material-icons">arrow_back</i>
                                    </div>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inlineFormInputGroup"
                                    placeholder={T.t('r_gen_search')}
                                    onKeyDown={this.searchOnKeyUp}
                                    onChange={this.searchOnChange}
                                    value={this.state.searchedWord}
                                />
                            </div>
                        </div>
                        </div>
                        <div className="announcementTabs">
                            {!this.props.classId ? (
                                <ul className="nav nav-tabs border-0" style={{ paddingInlineStart: '0px' }} id="tabs" role="tablist">
                                    <li className="nav-item" style={{ width: "50%" }}>
                                        <a
                                            className={currentTab === INBOX_TAB || '' ? 'nav-link active' : 'nav-link'}
                                            id="home-tab"
                                            data-toggle="tab"
                                            href="#home"
                                            role="tab"
                                            aria-controls="home"
                                            aria-selected="true"
                                            onClick={this.onTabChange.bind(this, INBOX_TAB)}
                                            style={{ textTransform: 'none' }}
                                        >
                                            {T.t('r_gen_incoming')}
                                        </a>
                                        {(currentTab === INBOX_TAB || currentTab === '') && this.props.unreadCount > 0 ? (
                                            <span className="count">
                                                {this.props.announcements && this.props.announcements.length
                                                    ? this.props.unreadCount
                                                    : 0}
                                            </span>
                                        ) : null}
                                    </li>
                                    {Common.HasPermission(SecurityContextType.Organization, SecurityPermissionType.Announcement_Add, '') &&
                                        !this.props.classId && (
                                            <li className="nav-item">
                                                <a
                                                    className={currentTab === SENT_TAB ? 'nav-link active' : 'nav-link'}
                                                    id="profile-tab"
                                                    data-toggle="tab"
                                                    href="#profile"
                                                    role="tab"
                                                    aria-controls="profile"
                                                    aria-selected="false"
                                                    onClick={this.onTabChange.bind(this, SENT_TAB)}
                                                    style={{ textTransform: 'none' }}
                                                >
                                                    {T.t('r_gen_sent')}
                                                </a>
                                            </li>
                                        )}
                                    {/* GELEN-GONDERILEN-ARSIV | arsiv şuan yok kaldırılıyor.
                                        {!this.props.classId ? (
                                            <li className="nav-item">
                                                <a
                                                    className={currentTab === ARCHIVE_TAB ? 'nav-link active' : 'nav-link'}
                                                    id="contact-tab"
                                                    data-toggle="tab"
                                                    href="#contact"
                                                    role="tab"
                                                    aria-controls="contact"
                                                    aria-selected="false"
                                                    onClick={this.onTabChange.bind(this, ARCHIVE_TAB)}
                                                >
                                                    {T.t('r_gen_archive')}
                                                </a>
                                                {currentTab === ARCHIVE_TAB? (
                                                    <span className="count">
                                                        {this.props.announcements && this.props.announcements.length
                                                            ? this.props.announcements[0].totalCount
                                                            : 0}
                                                    </span>
                                                ) : null}
                                            </li>
                                        ) : (
                                            ''
                                        )}
                                    */}
                                </ul>
                            ) : (
                                ''
                            )}
                            <Loading spinnerId={'selectedAnnouncement'}>
                                <div style={{ backgroundColor: '#eeede9' }}>
                                    <ContentLoader
                                        speed={2}
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        viewBox="0 0 350 900"
                                        style={{ width: '100%' }}
                                    >
                                        <circle cx="45" cy="65" r="27" />
                                        <rect x="95" y="38" rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y="61" rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y="86" rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces} r="27" />
                                        <rect x="95" y={38 + loadingSpaces} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 2} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 2} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 2} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 2} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 3} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 3} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 3} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 3} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 4} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 4} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 4} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 4} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 5} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 5} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 5} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 5} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 6} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 6} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 6} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 6} rx="0" ry="0" width="200" height="25" />

                                        <circle cx="45" cy={65 + loadingSpaces * 7} r="27" />
                                        <rect x="95" y={38 + loadingSpaces * 7} rx="0" ry="0" width="113" height="8" />
                                        <rect x="95" y={61 + loadingSpaces * 7} rx="0" ry="0" width="112" height="8" />
                                        <rect x="95" y={86 + loadingSpaces * 7} rx="0" ry="0" width="200" height="25" />

                                    </ContentLoader>
                                </div>
                            </Loading>
                            <div id="selectedAnnouncement_Content" className="tab-content" style={{ backgroundColor: '#eeede9' }}>
                                <div className="tab-pane fade show active" id="home" onClick={this.openAnnouncement} role="tabpanel" aria-labelledby="home-tab">
                                    {renderHtml}
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.selectedAnnouncement === null ?
                            <div className='custom-col-message-2'>
                                <div className="create-announcement text-center" >
                                    <div className='d-inline'>
                                        <img src={announcement} />
                                        <h5 style={{ textAlign: "center", paddingTop: "15px" }} >{T.t('r_announcements_not_found')}</h5>
                                        {T.t('r_announcements_replay_found')}
                                    </div>
                                </div>
                            </div>
                            :
                            <SelectedAnnouncement findDateFormat={this.findDateFormat} currentTab={currentTab} modalTrigger={this.modalTrigger} />
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAnnouncementPageProps): IAnnouncementPageProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IAnnouncementPageProps = Object.assign({}, ownProps, {
        announcements: state.announcement.announcements ? state.announcement.announcements : state.coursePage.announcements,
        courseAnnouncements: state.coursePage.announcements,
        announcementIsLoaded: state.announcement.announcementIsLoaded,
        selectedAnnouncement: state.announcement.selectedAnnouncement,
        announcementTake: state.announcement.announcementTake ? state.announcement.announcementTake : 20,
        announcementSkip: state.announcement.announcementSkip ? state.announcement.announcementSkip : 0,
        unreadCount: state.announcement.unreadAnnounceCount
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.announcement.unreadCount !== prev.announcement.unreadAnnounceCount; // ||
    // next.announcement.selectedAnnouncement !== prev.announcement.selectedAnnouncement;
    return false;
};

const CAnnouncementMain = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(AnnouncementMain);

export default CAnnouncementMain;
